import React from 'react'

export default function ImageCarousel({ images = [], alt = '' }) {
  const [i, setI] = React.useState(0)
  const go = (d) => setI(v => (v + d + images.length) % images.length)

  if (!images.length) {
    return (
      <img
        className="w-full max-h-[300px] object-cover rounded-xl border border-blue-100 shadow-sm"
        src="https://via.placeholder.com/800x450?text=Locapiol"
        alt={alt}
      />
    )
  }

  return (
    <div className="relative w-full max-h-[300px] overflow-hidden rounded-xl border border-blue-100 shadow-sm">
      <img
        className="w-full h-full object-cover transition-all duration-500"
        src={images[i]}
        alt={alt}
      />

      {images.length > 1 && (
        <>
          {/* Flèches */}
          <button
            onClick={() => go(-1)}
            className="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/80 border shadow flex items-center justify-center hover:bg-white"
            aria-label="Précédent"
          >
            ‹
          </button>
          <button
            onClick={() => go(1)}
            className="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-white/80 border shadow flex items-center justify-center hover:bg-white"
            aria-label="Suivant"
          >
            ›
          </button>

          {/* Petits indicateurs en bas */}
          <div className="absolute bottom-2 left-1/2 -translate-x-1/2 flex gap-1">
            {images.map((_, idx) => (
              <span
                key={idx}
                className={`w-2 h-2 rounded-full ${
                  idx === i ? 'bg-blue-600' : 'bg-white border border-blue-200'
                }`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  )
}
